import { computed, getCurrentInstance } from "@vue/composition-api";
export const useVuelidate = () => {
  const vueInstance = getCurrentInstance();
  return {
    v$: computed(() => vueInstance.scope.vm.$v)
  };
};